/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { FontAwesomeIcon, Heading, IMG, Stack } from "components";
import Image1 from "./image1.png";
import Image2 from "./image2.png";
import Image3 from "./image3.png";
import Image4 from "./image4.png";
import Image5 from "./image5.png";
import { FC } from "react";
import { useTranslation } from "react-i18next";

const IMAGES = [Image1, Image2, Image3, Image4, Image5];

type ListProps = {
  title?: string;
  items: string[];
  note?: string;
};

export const List: FC<ListProps> = ({ title, items, note }) => {
  return (
    <Stack className="-text--theme-colors-text-body">
      {title && (
        <Heading as="h2" className="-text--theme-colors-text-title">
          {title}
        </Heading>
      )}
      <Stack className={title ? "mt-5" : undefined}>
        {note && <span>{note}</span>}
        <ul className="list-disc list-inside">
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </Stack>
    </Stack>
  );
};

const PersonalImageInstructions = () => {
  const { t } = useTranslation();
  return (
    <Stack className="lg:px-40">
      <div className="grid place-items-center place-content-center grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
        {IMAGES.map((image, index) => (
          <div
            key={index}
            className="flex flex-col items-center space-y-5 odd:last-of-type:col-span-2 odd:last-of-type:sm:col-span-1"
          >
            <IMG
              key={index}
              src={image}
              alt="personal img"
              className="w-32 h-32 object-fill"
            />
            {index === 0 ? (
              <span className="-text--theme-colors-success-default">
                <FontAwesomeIcon name="fa-circle-check" size="2x" />
              </span>
            ) : (
              <span className="-text--theme-colors-danger-default">
                <FontAwesomeIcon name="fa-circle-xmark" size="2x" />
              </span>
            )}
          </div>
        ))}
      </div>
      <Stack className="mt-10 w-[90%] -bg--theme-colors-surface-neutral-level02 border -border--theme-colors-border-neutral-07 py-16 px-3 md:px-10 lg:px-16 max-w-5xl mx-auto space-y-8">
        <List
          items={
            t("instructions.personal.requirements", {
              returnObjects: true,
            }) as string[]
          }
        />
        <p className="-text--theme-colors-text-body">
          {t("instructions.personal.identityNote")}
        </p>
      </Stack>
    </Stack>
  );
};

export default PersonalImageInstructions;
